import { getUtente } from "../utils/user/api";

const state = {
  userDetails: null,
};

const getters = {
  getUserDetails: (state) => state.userDetails,
};

const actions = {
  makeUserDetails: async function (state) {
    const { data, result } = await getUtente();
    if (result === "OK") state.commit("setUserDetails", data);
  },
};

const mutations = {
  setUserDetails: function (state, userDetails) {
    state.userDetails = userDetails;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
